import { Checkmark16Icon } from "@components/icons";

export interface IPlanCardListItemProps {
  children?: React.ReactNode;
}

export const PlanCardListItem: React.FC<IPlanCardListItemProps> = (props) => {
  const { children } = props;

  return (
    <li className="flex items-start pb-3 last-of-type:pb-0">
      <Checkmark16Icon className="h-6 w-4 min-w-[1rem]" />
      <div className="pl-2">{children}</div>
    </li>
  );
};
